import * as React from "react";
import { IconImage } from "common/components/SerializedApp";
import ActionModal from "../action-modal/action-modal";
import { defined } from "common/Support";
import { GlideDropdown } from "designer/ui/smart/glide-dropdown/glide-dropdown";
import { Icon } from "common/render/icon";
import { styled } from "sharedUI/styles";
import { ItemDescription } from "designer/lib/dropdown-types";

type TransferModalChoice = Readonly<{ code: string; color: string; icon: IconImage | undefined; label: string }>;

type Props = Readonly<{
    header: React.ReactNode;
    dropdownLabel: string;
    choices: readonly TransferModalChoice[];
    onAccept: (r: string) => void;
    onCancel: () => void;
}>;

type State = Readonly<{
    selected: TransferModalChoice | undefined;
}>;

const EmptyIcon = styled.div`
    width: 24px;
    height: 24px;
`;

export default class TransferModal extends React.PureComponent<Props, State> {
    public state: State = { selected: undefined };

    private onAccept = () => {
        const { onAccept } = this.props;
        const { selected } = this.state;
        onAccept(defined(selected).code);
    };

    private onCancel = () => {
        const { onCancel } = this.props;
        onCancel();
    };

    private descriptionForItem = (i: TransferModalChoice): ItemDescription => {
        return {
            name: i.label,
            icon:
                i.icon === undefined ? (
                    <EmptyIcon />
                ) : (
                    <Icon size={24} image={i.icon} color={i.color} clipCorners={true} />
                ),
        };
    };

    private onItemSelected = (selected: TransferModalChoice) => {
        this.setState({ selected });
    };

    public render() {
        const { header, choices, dropdownLabel } = this.props;
        const { selected } = this.state;

        const dropdown = (
            <GlideDropdown<TransferModalChoice>
                tallerVariation={true}
                items={choices}
                selected={selected}
                descriptionForItem={this.descriptionForItem}
                onItemSelect={this.onItemSelected}
                defaultDisplayLabel="—"
            />
        );
        const description = (
            <div>
                <div>{dropdownLabel}</div>
                {dropdown}
            </div>
        );

        return (
            <ActionModal
                header={header}
                description={description}
                acceptText="Transfer"
                cancelText="Cancel"
                acceptAction={this.onAccept}
                cancelAction={this.onCancel}
                acceptDisabled={selected === undefined}
            />
        );
    }
}
